export default {
  init() {
    // JavaScript to be fired on the home page
    console.log('👋🏻 from home.ts'); // eslint-disable-line no-console
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
